import React from "react";
import PropTypes from "prop-types";
import { DropdownItem } from "reactstrap";

import Kebab from "./Kebab";

const ActionsKebab = ({ className, actions, ...props }) => (
  <Kebab className={className} {...props}>
    {actions.map(({ label, onClick, divider }) => (
      <DropdownItem key={label} onClick={onClick} divider={divider}>
        {label}
      </DropdownItem>
    ))}
  </Kebab>
);

ActionsKebab.propTypes = {
  /**
   * The list of actions to be converted into a Kebab
   *  */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The label of the action that is used as the selectable item
       */
      label: PropTypes.string.isRequired,
      /**
       *  The function to call on click of this action
       */
      onClick: PropTypes.func,
      /**
       * A bool to decide whether or not the DropdownItem becomes a divider
       */
      divider: PropTypes.bool
    })
  ).isRequired,
  /** A class to apply to the underlying Kebab component */
  className: PropTypes.string
};
export default ActionsKebab;
